module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"imprint":"Impressum","dataProtection":"Datenschutzerklärung"},"en":{"imprint":"Imprint","dataProtection":"Privacy policy"}}')
  delete Component.options._Ctor
}
